module.exports = __webpack_public_path__ + "static/habStill12-b0791f525a6b35ee487b69ed93f1409d.png";